import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { step1Schema, uiSchema } from './Schema';
import { Change } from '../FormPDFEditor/types';
import FormPDFEditor from '../FormPDFEditor';

interface Props {
  fetching: boolean;
  form: { id: string; url: string };
  onSave: (data: object) => void;
  onEdit: (changes: Change[]) => void;
}

export default function FormEditor({ fetching, form, onSave, onEdit }: Props) {
  const onSubmit = ({ formData }: { formData: object }) => onSave(formData);

  return (
    <div className="form-list-container">
      <Form
        schema={step1Schema}
        uiSchema={uiSchema}
        formData={form}
        onSubmit={onSubmit}
        enctype="multipart/form-data"
      >
        <Button
          bsClass="btn btn-primary btn-large"
          disabled={fetching}
          type="submit"
        >
          Save
        </Button>
      </Form>
      <br />
      <br />
      <FormPDFEditor
        formId={form.id}
        formUrl={form.url}
        fetching={fetching}
        onSave={onEdit}
      />
    </div>
  );
}

FormEditor.propTypes = {
  fetching: PropTypes.bool,
  form: PropTypes.object,
  onSave: PropTypes.func,
  onEdit: PropTypes.func,
};
